import { render, staticRenderFns } from "./SearchHintModal.vue?vue&type=template&id=129e22a3&"
import script from "./SearchHintModal.vue?vue&type=script&lang=js&"
export * from "./SearchHintModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconClose: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconClose.vue').default,Modal: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/base/Modal.vue').default})
